<template>
    <div class="col-md-12 col-lg-12 col-xl-9">
        <div class="sport-menu-tabs-sec">
            <walletHeader/>
            <section class="recent-wrapper walletPage-wrap">
                <div class="container">
                    <div class="payment-heading">
                        <h3>{{$t('add-account', 'Add account')}}</h3>
                    </div>
                    <template v-if="type === 'bank'">
                        <div class="withdraw-sec">
                            <div class="input-field position-relative">
                                <label class="form-label">{{ $t('bank-name','Bank Name')}}</label>
                                <input type="text" v-model="searchBank" class="form-control" placeholder="Search Bank Name" @focus="showDropdown = true" @blur="hideDropdown"/>
                                <ul v-if="showDropdown" class="dropdown-list">
                                    <template v-if="filteredBanks.length > 0">
                                        <li v-for="(item, index) in filteredBanks" :key="index" @mousedown="selectBank(item)">
                                            {{ item.bank_name }}
                                        </li>
                                    </template>
                                    <template v-else>
                                        <li class="no-data">
                                            {{ $t('no-data-found', 'No Data Found') }}
                                        </li>
                                    </template>
                                </ul>
                                <div class="thm-error-text" v-if="accountForm.errors.bankId && !accountForm.bankId">
                                    <div>
                                        <p class="wrong-color">{{$t('please-select-bank-name', 'Please select bank name.')}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="input-field">
                                <label class="form-label">{{ $t('account-holder-name','Account Holder’s Name')}}</label>
                                <input v-model="accountForm.holderName" class="form-control" type="text" maxlength="50" placeholder="Roni">
                                <div class="thm-error-text" v-if="accountForm.errors.holderName && !accountForm.holderName">
                                    <div>
                                        <p class="wrong-color">{{$t('please-enter-account-holder-name', 'Please enter account holder name.')}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="input-field">
                                <label class="form-label">{{ $t('account-number','Account number')}}</label>
                                <input  v-model="accountForm.accountNumber" class="form-control" type="text" placeholder="4444-5555-6666-2222" maxlength="50">
                                <div class="thm-error-text" v-if="accountForm.errors.accountNumber && !accountForm.accountNumber">
                                    <div>
                                        <p class="wrong-color">{{$t('please-enter-account-number', 'Please enter account number.')}}</p>
                                    </div>
                                </div>
                            </div>
                            <div class="input-field">
                                <label class="form-label">{{ $t('ifsc-code','IFSC Code')}}</label>
                                <input v-model="accountForm.ifscCode" class="form-control" type="text" placeholder="IDFB0042127" maxlength="50">
                                <div class="thm-error-text" v-if="accountForm.errors.ifscCode && !accountForm.ifscCode">
                                    <div>
                                        <p class="wrong-color">{{$t('please-enter-ifsc-code', 'Please enter IFSC code.')}}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </template>
                    <template v-else>
                        <div class="withdraw-sec">
                        <div class="input-field">
                            <label class="form-label">{{ $t('account-holder-name','Account Holder’s Name')}}</label>
                            <input v-model="accountForm.holderName" class="form-control" type="text" maxlength="50" :placeholder="$t('enter-account-holder-name', 'Enter Account Holders Name')">
                            <div class="thm-error-text" v-if="accountForm.errors.holderName && !accountForm.holderName">
                                <div>
                                    <p class="wrong-color">{{$t('please-enter-account-holder-name', 'Please enter account holder name.')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="input-field">
                            <label class="form-label">{{ $t('phone-number','Phone Number')}}</label>
                            <input v-model="accountForm.phoneNumber" class="form-control" type="text" maxlength="50" :placeholder="$t('enter-phone-number', 'Enter Phone Number')">
                            <div class="thm-error-text" v-if="accountForm.errors.phoneNumber && !accountForm.phoneNumber">
                                <div>
                                    <p class="wrong-color">{{$t('please-enter-phone-number', 'Please enter phone number.')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="input-field" v-if="type == 'upi'">
                            <label class="form-label">{{ $t('upi-id','UPI Id')}}</label>
                            <input v-model="accountForm.upiId" class="form-control profit-input" type="text" maxlength="50" :placeholder="$t('enter-upi-id','Enter UPI ID')">
                            <div class="thm-error-text" v-if="accountForm.errors.upiId && !accountForm.upiId">
                                <div>
                                    <p class="wrong-color">{{$t('please-enter-upi-id', 'Please enter UPI Id.')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="input-field" v-if="type == 'wallet'">
                            <label class="form-label">{{ $t('wallet-id','Wallet ID')}}</label>
                            <input v-model="accountForm.walletId" class="form-control profit-input" type="text" maxlength="50" :placeholder="$t('enter-wallet-id','Enter Wallet ID')">
                            <div class="thm-error-text" v-if="accountForm.errors.walletId && !accountForm.walletId">
                                <div>
                                    <p class="wrong-color">{{$t('please-enter-wallet-id', 'Please enter Wallet ID.')}}</p>
                                </div>
                            </div>
                        </div>
                        <div class="input-field">
                            <h5 class="uploadFile-title-wrap">{{$t('qr-code-upload-screenshot', 'Qr code (upload screenshot)')}}
                                <span class="info-sec-icon upload-qr-code-tooltips">
                                    <img src="@/assets/images/info-icon.svg" alt="info-icon" loading="lazy">
                                    <div class="info-tooltip">
                                        <ul>
                                            <li>1. {{$t('upload-a-screenshot-of-a-valid-qr-code-to-proceed', 'Upload a screenshot of a valid QR code to proceed.')}}</li>
                                            <li>2. {{$t('if-qr-code-is-not-detected-exchange-will-not-be-responsible-for-the-losses', 'If QR code is not detected, Exchange will not be responsible for the losses')}}</li>
                                        </ul>
                                    </div>
                                </span>
                            </h5>
                            <div class="uploadFile-wrap" v-if="!accountForm.file">
                                <div class="file-upload-sec">
                                    <label for="file" class="file-upload">
                                        <img loading="lazy" src="@/assets/images/file-icon.svg" alt="file-icon">
                                        <h6>{{$t('upload-screenshot', 'Upload screenshot')}}</h6>
                                    </label>
                                    <input class="form-control profit-input d-none" type="file" name="file" multiple
                                            id="file" @change="fileUpdateFunc">
                                </div>
                            </div>
                            <div class="uploadFile-wrap" v-if="accountForm.file">
                                <div class="fileList fileList-name">
                                    <div class="fileList-name-text" :title="accountForm.file.name">{{ accountForm.file.name }}</div>
                                    <button class="add-utr-again" @click="accountForm.file = null">&#10006;</button>
                                </div>
                            </div>
                            <div class="thm-error-text" v-if="accountForm.errors.file && !accountForm.file">
                                <div>
                                    <p class="wrong-color">{{$t('please-upload-qr-code', 'Please upload Qr code.')}}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    </template>
                    <template v-if="is_withdrawal_password_set">
                        <div class="withdraw-sec">
                            <div class="input-field position-relative">
                                <label class="form-label">{{ $t('withdrawal-password','Withdrawal Password')}}</label>
                                <input v-model="accountForm.withdrawal_password" :type="passwordFieldType" class="form-control" 
                                    @input="accountForm.withdrawal_password = $helper.sanitizeDetails('withdrawPassword', accountForm.withdrawal_password, 20)"  
                                    :placeholder="$t('withdrawal-password', 'Withdrawal Password')">
                                <div class="thm-error-text" v-if="accountForm.errors.withdrawal_password && !accountForm.withdrawal_password">
                                    <div>
                                        <p class="wrong-color">{{$t('please-enter-withdraw-password', 'Please Enter Withdraw Password')}}</p>
                                    </div>
                                </div>
                                <div class="score-hide-show" @click="togglePasswordVisibility('passwordField')">
                                    <img loading="lazy" rel="preload" class="w-25" v-if="passwordFieldType === 'password'" src="@/assets/images/eye-close.png">
                                    <img loading="lazy" rel="preload" class="w-25" v-else src="@/assets/images/eye-open.webp" alt="">
                                </div>
                            </div>
                            <a href="javascript:void(0)" class="blue-link mt-1" @click="openWithdrawPasswordModal()">
                                {{ $t('forgot-withDraw-password', 'Forgot Withdraw Password') }}?
                            </a>
                        </div>
                    </template>
                    <div class="withdraw-fix-sec continue-btn">
                        <a @click="addAccountFunctionCall()" class="btnTheme-yellow " :class="{ 'btn-loading': loading }">
                            {{$t('add-account', 'Add Account')}} <span><b></b><b></b><b></b></span>
                        </a>
                    </div>
                </div>
            </section>

            <WithdrawalPasswordSetReset ref="withdrawSetReset" :isWithdrawalPasswordSet="isWithdrawalPasswordSet" 
            :is_withdrawal_password_set="is_withdrawal_password_set"  @withdrawalPasswordHasBeenSet="is_withdrawal_password_set = true"/>

            <div class="modal fade modal-footer-sticky worli-Bets-Modal" id="checkWithdrawPassModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
                <div class="modal-dialog modal-dialog-centered">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5>{{$t('withDraw-password','Withdraw password')}}</h5>
                            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div class="modal-body">
                            <div class="account-delete-msg">
                                <p>{{$t('skip-msg','Withdraw password not set. Continue to add or skip')}}..!!</p>
                            </div>
                        </div>
                        <div class="modal-footer">
                            <button @click="addAccountServiceCall(true)" id="closeBtn" type="button" class="thm-but thm-bor-but" data-bs-dismiss="modal">
                                {{ $t('skip', 'Skip') }}
                            </button>
                            <button @click="openWithdrawPasswordModal()" data-bs-dismiss="modal" type="button" class="thm-but save-notification">
                                {{ $t('continue', 'Continue') }}
                            </button>
                        </div>
                    </div>
                </div>
            </div>

        </div>
        <Support></Support>
    </div>
</template>

<script>
import { defineAsyncComponent } from 'vue';
import WithdrawalPasswordSetReset from '../components/WithdrawalPasswordSetReset.vue';
import WalletHeader from '../components/WalletHeader.vue';
import Support from '@/shared/components/support/Support.vue';
export default {
    name: 'AddWithdrawAccount',
    components: {
        Support,
        WalletHeader,
        WithdrawalPasswordSetReset,
    },
    data() {
        return {
            loading: false,
            type: null,
            accountForm: {
                bankId: '',
                holderName: '',
                accountNumber: '',
                ifscCode: '',
                phoneNumber: '',
                upiId: '',
                walletId: '',
                file: null,
                errors: {},
                withdrawal_password: null
            },
            is_withdrawal_password_set:false,
            searchBank: "",
            showDropdown: false,
            passwordFieldType: 'password',
        }
    },
    computed:{
        filteredBanks() {
            return this.bankDetailsList.filter(bank =>
                bank.bank_name.toLowerCase().includes(this.searchBank.toLowerCase())
            );
        }
    },
    mounted() {
        const item = JSON.parse(this.$route.params.type);
        this.type = item.type;
        this.accountForm.paymentMethodId = item.id;
        this.accountForm.paymentTypeName = item.name;
        this.getBankDetailsServiceCall()
        this.isWithdrawalPasswordSet()
    },
    methods: {
        addAccountFunctionCall() {
            if (this.loading) return;
            this.clearErrors();
            if (this.validateForm()) {
                this.addAccountServiceCall();
            }
        },
        validateForm() {
            const requiredFields = {
                bank: ["bankId", "holderName", "accountNumber", "ifscCode"],
                upi: ["holderName", "phoneNumber", "upiId", "file"],
                wallet: ["holderName", "phoneNumber", "walletId", "file"]
            }[this.type];

            requiredFields.forEach(field => {
                if (!this.accountForm[field]) this.accountForm.errors[field] = true;
            });

            return Object.keys(this.accountForm.errors).length === 0;
        },
        clearErrors() {
            this.accountForm.errors = {};
        },
        getBankDetailsServiceCall() {
            this.loading = true;
            this.$apiCall('get', 'BANK_DETAILS', null, 'wallet').then(response => {
                this.loading = false;
                if (response?.status === 200) {
                        const data = response.data;
                        if (data.status === 0) {
                            this.$errorToast(data.debug[0]);
                        } else {
                            this.bankDetailsList = data.data;
                        }
                    }
            }).catch(error => {
                this.loading = false;
                if (error) {
                    console.log("Error : ", error[0]);
                    this.$errorToast(error[0])
                }
            });
        },
        addAccountServiceCall(skipWithdrawPassword = false) {
            this.loading = true;
            let data;
            if(!this.is_withdrawal_password_set && !skipWithdrawPassword) {
                this.$helper.openModal('#checkWithdrawPassModal');
                return;
            }
            if (this.type === 'bank') {
                data = {
					payment_type_id: this.accountForm.paymentMethodId,
					payment_type_name: this.accountForm.paymentTypeName,
					bank_id: this.accountForm.bankId,
					account_holder_name: this.accountForm.holderName,
					account_no: this.accountForm.accountNumber,
					ifsc_code: this.accountForm.ifscCode,
					type: this.type,
                    withdrawal_password: this.accountForm.withdrawal_password
				};
                if(this.is_withdrawal_password_set) {
                    data.withdrawal_password = this.accountForm.withdrawal_password
                }
            } else {
                data = new FormData();
				data.append("account_holder_name", this.accountForm.holderName);
				data.append("payment_type_id", this.accountForm.paymentMethodId);
				data.append("payment_type_name", this.accountForm.paymentTypeName);
				data.append("phone_no", this.accountForm.phoneNumber);
				data.append("type", this.type);
				data.append(this.type === 'upi' ? "upi_id" : "wallet_id", this.accountForm[this.type + "Id"]);
				data.append("qr_code", this.accountForm.file);
                if(this.is_withdrawal_password_set) {
                    data.append("withdrawal_password",this.accountForm.withdrawal_password);
                }
            }
            this.$apiCall('post', 'ADD_ACCOUNT', data , 'wallet', null, 'changeHeaderContent')
                .then(this.handleResponse)
                .catch(this.handleError);
        },
        handleResponse(response) {
            this.loading = false;
            const message = response.data?.status === 0 ? response.data.debug[0] : response.data.data.message;
            response.data?.status === 0 ? this.$errorToast(message) : this.$successToast(message);
            if (document.getElementById('checkWithdrawPassModal')) {
                this.$helper.closeModal('checkWithdrawPassModal');
            }
            if (response.data?.status !== 0) this.$router.back();
        },
        handleError(error) {
            this.loading = false;
            this.$errorToast(error?.[0]);
        },
        hideDropdown() {
            setTimeout(() => {
                if (this.filteredBanks.length === 0) {
                    this.searchBank = "";
                }
                this.showDropdown = false;
            }, 200);
        },
        selectBank(bank) {
            this.searchBank = bank.bank_name; 
            this.accountForm.bankId = bank.id;
            this.showDropdown = false;
        },
        togglePasswordVisibility() {
            this.passwordFieldType = this.passwordFieldType === 'password' ? 'text' : 'password';
        },
        openWithdrawPasswordModal(){
            try{
                this.$helper.closeModal('withdrawalPasswordWarning');
                this.$apiCall('get', 'SENT_OTP_TO_MOBILE', null, 'wallet', null).then(res => {
                    if(res.status == 200){
                        let data = res.data;
                        let { status } = data.data;
                        let message = data?.message
                    if(status == 1){
                        this.$refs.withdrawSetReset.assignWithdrawPhoneNumber(data.data.phone_no)
                        this.$helper.openModal('#withdrawalPassword')
                        this.$refs.withdrawSetReset.otpHasBeenCalled()
                        this.$successToast(message);
                        this.$refs.withdrawSetReset.resetTimer();
                    }else{
                        this.addAccountServiceCall(true);
                        this.$errorToast(message);
                    }
                    }
                });
            }
            catch(error){
                console.log("============",error.response.data.errors)
            }
        },
        isWithdrawalPasswordSet(){
            try {
                this.$apiCall('get', 'CHECK_WITHDRAWAL_PASSWORD', null, 'wallet', null).then(response => {
                    if(response.status == 200){
                        this.is_withdrawal_password_set = response.data.status;
                        if(this.is_withdrawal_password_set){
                            this.addAccountServiceCall();
                            return;
                        }
                    }
                });
                
            } catch (error) {
                const message = sendError(error);
                console.log("============",message)
            }
        }
    }

}
</script>


<style scoped>
.wrong-color{
    color: red;
}
.dropdown-list {
    position: absolute;
    width: 100%;
    max-height: 200px;
    overflow-y: auto;
    background: white;
    border: 1px solid #ccc;
    list-style: none;
    padding: 0;
    margin: 0;
    z-index: 1000;
}

.dropdown-list li {
    padding: 10px;
    cursor: pointer;
}

.dropdown-list li:hover {
    background: #f0f0f0;
}
.score-hide-show img {
    position: absolute;
    top: 36px;
    right: 10px;
    width: 18px !important;
}
.modal-footer{
    flex-wrap: nowrap !important;
}
</style>